<template>
    <div class="col-sm-12 list-content-item mb-2">
        <div class="row">
            <div class="col-auto image-container">
                <avatar-badge :src="displayImage" :raised="false" :size="100"></avatar-badge>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-lg-9">
                        <h2 class="title" v-text="service.name"></h2>
                    </div>
                    <div class="col-lg-3 text-lg-right text-left mt-sm--2 mt-lg-0">
                        PHP<span class="text-lg" v-text="displayedPrice"></span>
                    </div>
                </div>

                <div class="description mb-2" v-if="service.type == 'service'">{{ category.name }} - {{ subcategory.name }}</div>
                <div class="description mb-2" v-else v-text="displayedPackageItems"></div>

                <div class="description text-default">Duration: {{ displayedDuration }} <span class="text-muted">(each)</span></div>
                <div v-if="service.type == 'service'" class="description text-default ">
                    Selected experts:
                        <span v-if="experts.length > 0" v-text="displayedExperts"></span>
                        <span v-else class="text-muted">No experts selected</span>
                </div>
                <div class="description text-default ">Quantity: {{ quantity }}</div>
                <div class="text-right">
                    <button v-if="hasRemainingItemsInTransaction" @click.prevent="removeService" class="btn btn-sm btn-danger">
                        <i class="fa fa-trash mr-1"></i> Delete
                    </button>
                    <button @click.prevent="editService" class="btn btn-sm btn-warning">
                        <i class="fa fa-pen mr-1"></i> Edit 
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { bus } from "@utils/bus";
import mixins from "@utils/mixins";
import moment from "moment";
import { getDisplayedDuration } from "@utils/helpers";

export default {
    name: "ServiceListItem",

    computed: {
        category() {
            return this.subcategory.category || {};
        },
        subcategory() {
            return this.service.subcategory || {};
        },
        displayImage() {
            return this.service.display_image || "/images/placeholders/avatar.jpg";
        },
        displayedPrice() {
            return parseFloat(this.service.price || 0).toFixed(2);
        },
        displayedPackageItems() {
            return this.service.items
                ? this.service.items.map(item => item.name).join(", ")
                : "";
        },
        hasRemainingItemsInTransaction() {
            return this.$parent.packages.length + this.$parent.services.length > 1;
        },
        displayedDuration() {
            return getDisplayedDuration(this.service.duration || 0);
        },
        displayedExperts() {
            if (this.service.type != "service") {
                return "";
            }
            return this.experts.length > 0
                ? this.experts.map(expert => expert.fullname).join(", ")
                : "No experts selected";
        },
    },
    data: () => ({
        experts: [],
        quantity: 0,
    }),

    methods: {
        editService() {
            this.$emit("update", this.service);
        },
        async removeService() {
            if (!(await this.confirm("Are you sure you want to remove this item?", "")).value) {
                return;
            }
            this.$emit("remove", this.service);
        },
        getServiceList() {
            return this.service.type == "package"
                ? this.$parent.$parent.packages
                : this.$parent.$parent.services;
        },
        refreshService(service) {
            this.quantity = service.quantity || 0;

            if (this.service.type == "package") return;
            if (!Array.isArray(service.selectedExperts) || service.selectedExperts.length == 0) return;

            this.experts = [...service.selectedExperts];
        },
    },

    mixins: [mixins],
    
    props: {
        service: [Object],
    },

    mounted() {
        bus.$on(`service-updated-${ this.service.id }`, this.refreshService);
        this.refreshService(this.service);
    },

    beforeDestroy() {
        bus.$off(`service-updated-${ this.service.id }`);
    }
}
</script>